import { useState, useEffect } from "react";
import {
  Box,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from "@mui/material";
import { imgUrl, url } from "src/Helpers/utils/Constant";
import { useParams } from "react-router-dom";
import axios from "axios";
import ModalsWrapper from "src/components/Modals/ModalsWrapper";
import {
  IRepresentativeInfo,
  IRepresentativeInfoResponse,
} from "src/Types/module/member/CompanyInformation";
import UpdateCompanyRepresentativeInfo from "../../../CompanyAddInfo/UpdateCompanyInformation/UpdateCompanyRepresentativeInfo";
import AddRepresentativeInfo from "../../../CompanyAddInfo/CompanyAddInfoComponents/AddRepresentativeInfo";
import GlobalLoader from "src/components/SuspenseLoader/GlobalLoader";
import PageTitleWrapper from "src/components/PageTitleWrapper";
import PageTitle from "src/components/PageTitle";
import { HttpClient } from "src/Helpers/http/http";
import PdfAndImageView from "src/components/pdfAndImageView/PdfAndImageView";
import { CommonTypoGraphy } from "src/components/pdfAndImageView/CommonTypoGraphy";

const RepresentativeInfo = () => {
  const { memberId } = useParams();
  const [open, setOpen] = useState<boolean>(false);
  const [refresh, setRefresh] = useState<boolean>(false);
  const [representativeInfo, setRepresentativeInfo] =
    useState<IRepresentativeInfo>({} as IRepresentativeInfo);
  const [loading, setLoading] = useState(false);
  const [imageViewOpen, SetImageViewOpen] = useState<boolean>(false);
  const [imageFile, setImageFile] = useState<string | null>("");

  useEffect(() => {
    setLoading(true);
    (async function () {
      try {
        const data: IRepresentativeInfoResponse = await HttpClient.get(
          `/api/atab/admin/member-company/representative/${memberId}`
        );
        if (data.success) {
          setRepresentativeInfo(data.data);
          setLoading(false);
        } else {
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
      }
    })();
  }, [memberId, refresh]);

  const {
    user_member_representative_name,
    user_member_representative_full_address,
    user_member_representative_nid_no,
    user_member_representative_phone,
    user_member_representative_designation,
    user_member_representative_nid_file,
    user_member_representative_photo,
  } = representativeInfo || {};
  return (
    <>
      {/* {applied ? ( */}
      <>
        <PageTitleWrapper>
          <PageTitle
            heading="Representative information"
            actionButtonTitle={
              user_member_representative_name ? "Update" : "Add"
            }
            setAction={setOpen}
          />
        </PageTitleWrapper>
        {loading ? (
          <GlobalLoader />
        ) : (
          <>
            {user_member_representative_name ? (
              <Grid sx={{ pb: 5 }} container spacing={2}>
                <Grid item xs={12} md={6}>
                  <TableContainer component={Paper}>
                    <Table aria-label="custom pagination table">
                      <TableBody>
                        <TableRow>
                          <TableCell component="th" scope="row">
                            Representative name:
                          </TableCell>
                          <TableCell align="right">
                            {user_member_representative_name
                              ? user_member_representative_name
                              : "Not provided"}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell component="th" scope="row">
                            Representative designation:
                          </TableCell>
                          <TableCell align="right">
                            {user_member_representative_designation
                              ? user_member_representative_designation
                              : "Not provided"}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell component="th" scope="row">
                            Representative phone no:
                          </TableCell>
                          <TableCell align="right">
                            {user_member_representative_phone
                              ? user_member_representative_phone
                              : "Not provided"}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell component="th" scope="row">
                            Representative address:
                          </TableCell>
                          <TableCell align="right">
                            {user_member_representative_full_address
                              ? user_member_representative_full_address
                              : "Not provided"}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Grid>
                <Grid item xs={12} md={6}>
                  <TableContainer component={Paper}>
                    <Table aria-label="custom pagination table">
                      <TableBody>
                        <TableRow>
                          <TableCell component="th" scope="row">
                            Representative photo:
                          </TableCell>
                          <TableCell align="right">
                            {user_member_representative_photo ? (
                              <CommonTypoGraphy
                                name="View"
                                onClick={() => {
                                  SetImageViewOpen(true);
                                  setImageFile(
                                    user_member_representative_photo
                                  );
                                }}
                              />
                            ) : (
                              "Not provided"
                            )}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell component="th" scope="row">
                            Representative nid no:
                          </TableCell>
                          <TableCell align="right">
                            {user_member_representative_nid_no
                              ? user_member_representative_nid_no
                              : "Not provided"}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell component="th" scope="row">
                            Representative nid photo:
                          </TableCell>
                          <TableCell align="right">
                            {user_member_representative_nid_file ? (
                              <CommonTypoGraphy
                                name="View"
                                onClick={() => {
                                  SetImageViewOpen(true);
                                  setImageFile(
                                    user_member_representative_nid_file
                                  );
                                }}
                              />
                            ) : (
                              "Not provided"
                            )}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Grid>
              </Grid>
            ) : (
              <Typography
                variant="h3"
                gutterBottom
                sx={{ textAlign: "center" }}
              >
                No data found
              </Typography>
            )}
          </>
        )}
      </>
      {/* ) : (
        <Typography variant="h3" gutterBottom sx={{ textAlign: "center" }}>
          No data found
        </Typography>
      )} */}

      <ModalsWrapper
        setShowModal={setOpen}
        showModal={open}
        modalData={{
          title: user_member_representative_name
            ? "Update representative information"
            : "Add representative information",
        }}
      >
        {user_member_representative_name ? (
          <UpdateCompanyRepresentativeInfo
            representativeInfo={representativeInfo}
            memberId={memberId}
            setRefresh={setRefresh}
            setOpen={setOpen}
            refresh={refresh}
          />
        ) : (
          <AddRepresentativeInfo
            memberId={memberId}
            setRefresh={setRefresh}
            setOpen={setOpen}
            refresh={refresh}
          />
        )}
      </ModalsWrapper>

      <PdfAndImageView
        setOpen={SetImageViewOpen}
        open={imageViewOpen}
        file={imageFile}
      />
    </>
  );
};

export default RepresentativeInfo;
